import React, { useState, useMemo } from "react";
import InputLogo from "../../common/InputLogo/InputLogo";
import Input from "../../common/Input/Input";
import Button from "../../common/Button/Button";
import { Toaster } from "../../common/Toaster/Toaster";
import { useNavigate } from "react-router-dom";
import { forgotPasswordOtp } from "../../service/AuthWellDhanService";
import { useUtils } from "../../context/UtilsContext";
import { validateEmailWithFlexDomain } from "../../utils/validation.util";

function ForgotPasswordComponent() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  // Get session/profile utils from context
  const { sessionUtils, utilsLoading } = useUtils();

  const eventTypes = useMemo(
    () => sessionUtils?.event_types?.[0]?.event_types || [],
    [sessionUtils]
  );
  const appVersionId = sessionUtils?.app_versions?.[0]?.id;
  const forgotPasswordEventId = eventTypes.find(
    (x) => x.description === "forgot_password_otp"
  )?.id;
  const signinModeId = sessionUtils?.signin_modes?.find(
    (x) => x.description === "welldhan_id"
  )?.id;
  const forgotPasswordUpdateEventId = eventTypes.find(
    (x) => x.description === "forgot_password_update"
  )?.id;

  if (utilsLoading || !sessionUtils) {
    return <div>Loading...</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    const emailError = validateEmailWithFlexDomain(email);
    if (emailError) {
      setError(emailError);
      return;
    }

    const payload = {
      company_name: "flexcellence",
      application_name: "flexboard",
      app_version_id: appVersionId,
      event_type_id: forgotPasswordEventId,
      signin_mode_id: signinModeId,
      login_input: email,
    };

    const result = await forgotPasswordOtp(payload);
    if (result.success) {
      if (result.data?.data?.access_token) {
        localStorage.setItem("access_token", result.data.data.access_token);
      }
      setSuccess("OTP sent. Please check your email.");
      setTimeout(() => {
        navigate("/otp", {
          state: {
            email,
            type: "forgot",
            event_type_id: forgotPasswordUpdateEventId,
          },
        });
      }, 1200);
    } else {
      setError(result.message || "Failed to send OTP.");
    }
  };

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center ">
      {error && <Toaster message={error} type="error" />}
      {success && <Toaster message={success} type="success" />}
      <div className="bg-app-bg w-full max-w-md mx-auto rounded-2xl shadow-lg p-8 flex flex-col items-center">
        <InputLogo text="Forgot Password" />
        <form className="w-full flex flex-col gap-4 items-center" onSubmit={handleSubmit}>
          <Input
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            validate={validateEmailWithFlexDomain}
            className="w-full bg-input-bg"
          />
          <Button
            type="submit"
            text="Send OTP"
            className="bg-orange-primary text-white w-full rounded-lg mt-4 py-2 text-lg font-semibold"
            disabled={utilsLoading}
          />
        </form>
        <div className="w-full text-center mt-4 text-xs">
          <span
            className="text-orange-primary cursor-pointer underline"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </span>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordComponent;
